import { Component, OnInit, Input, Output, EventEmitter, forwardRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => YearPickerComponent),
  multi: true
};

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class YearPickerComponent implements OnInit {

  @Input() label: string;
  @Input() min: number;
  @Input() max: number;
  @Output() selectedYear = new EventEmitter();
 
  years:any = [];
  selectedValue:any;
  submit:boolean = false;
  yearTo:number;
  yearFrom:number;
  calenderYear:any = [];
  @ViewChild('ngSelectControl') ngSelectControl: NgSelectComponent;

 

  /**
   *Creates an instance of YearPickerComponent.
   * @memberof YearPickerComponent
   */

  ngOnInit() {
      this.yearTo = this.min;
      this.yearFrom = this.min + 15;
      this.getCalenderData();
  }

  getCalenderData(){
    this.calenderYear = [];
    for(let yearTo = this.yearTo; yearTo <= this.yearFrom; yearTo++){
      this.calenderYear.push(yearTo);
    }
  }

  apply(){
    this.submit = true;
    this.selectedValue = {startYear: this.years[0], endYear: this.years[1]}
    this.selectedYear.emit(this.selectedValue);
    this.ngSelectControl.close();
  }

  reset(){
    this.years = [];
    if(this.selectedValue.startYear > 0){
      this.years.push(this.selectedValue.startYear);
    }
    if(this.selectedValue.endYear > 0){
      this.years.push(this.selectedValue.endYear);
    }
    this.ngSelectControl.close();
  }



  selectYear(value:number)
  {
    if(this.years.length>=2){
      this.years= [];
    }
    this.years.push(value);
    this.years.sort();
  }
  public getPlaceholder(){
    let placeholder = this.label;
    if(this.submit && this.selectedValue.startYear > 0 && this.selectedValue.endYear > 0){
      placeholder = this.selectedValue.startYear + ' - ' +  this.selectedValue.endYear;
    }
    return placeholder;
  }

  prevNextYear(value){
    if(value == 'prev'){
      this.yearTo = this.yearTo-16;
      this.yearFrom = this.yearTo + 15;
    }
    else{
      this.yearFrom = this.yearFrom + 16;
      this.yearTo = this.yearFrom - 15;
    }
    this.getCalenderData();
  }
}